









































import { Component, Vue } from "vue-property-decorator";
import { GrupoModel, GRUPO_DEFAULT } from "@/models/administracao/usuario/GrupoModel";
import { FiltroCadastroUsuarioModel, FILTRO_DEFAULT } from "@/models/administracao/usuario/FiltroCadastroUsuarioModel";

@Component
export default class ListagemUsuarios extends Vue {
  filtro: FiltroCadastroUsuarioModel =FILTRO_DEFAULT();

  filtrar() {
  }
}
